import { Style } from '@/components/style';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StoreUtils from '@/utils/storeInfoUtils';
import OrderServeType from '@/constants/OrderServeType';
import { isEmpty } from 'lodash';
import ServeTypeUtils from '@/components/customizeWelcome/utils/serveTypeUtils';

const { alertColor, blackColor, primaryColor, gray3Color } =
  new Style().getUiConfig();

function ServeTypeRow({ webStoreVo, selectedServeType, setSelectedServeType }) {
  const style = new Style();
  const [availableServeTypes, setAvailableServeTypes] = useState<any>([]);
  const [availableTakeOutServeTypes, setAvailableTakeOutServeTypes] =
    useState<any>([]);
  useEffect(() => {
    const filterAvailableServeTypes =
      ServeTypeUtils.checkStoreServeTypeConfig(webStoreVo);
    if (!isEmpty(filterAvailableServeTypes)) {
      setAvailableServeTypes(filterAvailableServeTypes);
      setSelectedServeType(filterAvailableServeTypes[0]);
    }

    if (!isEmpty(webStoreVo?.availableTakeOutServeTypes)) {
      setAvailableTakeOutServeTypes(webStoreVo.availableTakeOutServeTypes);
    }
  }, [webStoreVo]);

  const setBtnRoundStyle = (index) => {
    if (isEmpty(availableServeTypes)) return '';

    if (availableServeTypes.length === 1) {
      return 'serveType-btn-rounded-one';
    }

    if (availableServeTypes.length >= 2) {
      if (index === 0) {
        return 'serveType-btn-rounded-left';
      }

      if (index === availableServeTypes.length - 1)
        return 'serveType-btn-rounded-right';
    }
    return 'serveType-btn-no-rounded';
  };

  const setBtnWidth = () => {
    if (isEmpty(availableServeTypes)) return '100%';

    if (availableServeTypes.length === 1) {
      return '100%';
    }

    if (availableServeTypes.length === 2) {
      return '48%';
    }

    if (availableServeTypes.length >= 3) {
      return '32%';
    }

    return '100%';
  };

  return (
    <div
      className={
        availableServeTypes.length < 3
          ? 'd-flex w-100 justify-content-around mb-3'
          : 'd-flex w-100 justify-content-between mb-3'
      }
      style={{ marginTop: '40px' }}
    >
      {availableServeTypes.map((serveType: OrderServeType, i: number) => {
        return (
          <div key={i} className="d-flex" style={{ width: setBtnWidth() }}>
            <div
              role="presentation"
              className={`${setBtnRoundStyle(
                i
              )} serveType-btn d-flex align-items-center justify-content-center`}
              style={
                selectedServeType === serveType
                  ? style.primaryBtnSelected()
                  : style.primaryBtn()
              }
              onClick={() => {
                setSelectedServeType(serveType);
              }}
            >
              <FormattedMessage
                id={`welcome.availableServeTypes.${serveType}`}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}

ServeTypeRow.defaultProps = {};

ServeTypeRow.propTypes = {
  webStoreVo: PropTypes.shape({
    availableServeTypes: PropTypes.arrayOf(PropTypes.string),
    availableTakeOutServeTypes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  selectedServeType: PropTypes.string.isRequired,
  setSelectedServeType: PropTypes.func.isRequired,
};

export default ServeTypeRow;
